import controller from './thing-notes.controller';

const template = require('./thing-notes.html');

export default {
    bindings: {
        reset: '<',
        notes: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-notes/thing-notes.component.js